import React from 'react'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import Button from '~/components/common/button'
import Modal from '~/components/common/modal'
import { hideDialog } from '~/actions/ui'

const WarningLabel = styled.div`
  ${({ theme }) => ({ ...theme._neo.bodyBold02 })}
  background: ${props => props.theme.backgroundWarning};
  border-radius: 5px;
  padding: 16px;
`

const StyledUpdatePasswordButton = styled(Button)`
  min-width: 150px;
`

const StyledCancelButton = styled(Button)`
  min-width: 110px;
`

const ConfirmUpdatePasswordScreen = ({ addPassword }) => (
  <Modal
    footerChildren={(
      <>
        <StyledUpdatePasswordButton onClick={addPassword}>
          {translate('update_password')}
        </StyledUpdatePasswordButton>
        <StyledCancelButton secondary onClick={hideDialog}>
          {translate('cancel')}
        </StyledCancelButton>
      </>
    )}
    title={translate('confirm_update_password')}
  >

    <WarningLabel>{translate('update_upcoming_meetings_warning')}</WarningLabel>
  </Modal>
)

export default ConfirmUpdatePasswordScreen
